"use client";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

export type UserAvatarSize = "sm" | "md" | "lg" | "xl";

export interface UserAvatarProps {
    name?: string | null;
    email?: string | null;
    size?: UserAvatarSize;
    className?: string;
}

const sizeClasses: Record<UserAvatarSize, string> = {
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-12 w-12",
    xl: "h-16 w-16",
};

export function UserAvatar({
    name,
    email,
    size = "md",
    className,
}: UserAvatarProps) {
    const initials = (name || email || "?")
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);

    return (
        <Avatar className={cn(sizeClasses[size], className)}>
            <AvatarFallback>{initials}</AvatarFallback>
        </Avatar>
    );
}
